import { useSeekaConverge } from '@seeka-labs/converge-react';
import { useCart } from '@shopify/hydrogen-react';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { FullScreenLoading } from '../../components/fullScreenLoading';

const ShopifyLogoutCallback = () => {
  const { buyerIdentityUpdate } = useCart();

  const converge = useSeekaConverge()

  useEffect(() => {
    const handleCallback = async () => {
      if (typeof window === 'undefined') {
        return
      }
      Cookies.remove('shopify_access_token');
      Cookies.remove('shopify_id_token');
      Cookies.remove('shopify_customer_wholesale');
      Cookies.remove('shopify_customer_tags');
      Cookies.remove('shopify_customer_email');

      buyerIdentityUpdate({
        customerAccessToken: null,
        email: null,
        phone: null,
      })

      try {
        await converge.track.custom('UserLogout')
      }
      finally {
        window.location.href = '/'; // must reload to respect clearing of cookies and UI to refresh
      }
    }

    handleCallback();
  }, []);

  return (
    <FullScreenLoading text={'Logging you out of Bloo cyber systems'} />
  );
};

export default ShopifyLogoutCallback;